// C:\MonProjet\BBW_DELEGUER\preprod\babyworld-backoffice\babyworld-backoffice\src\redux\slices\stocks\stocksThunk.js

import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosService from "../../../services/axiosServicesVisit";
import { API_URL } from "../../../config/api"; 

const getUrl = (path) => {
    const base = API_URL.endsWith('/api') ? API_URL : `${API_URL}/api`;
    return `${base}/v1${path}`;
};

export const getDelegateStock = createAsyncThunk(
  "stocks/getDelegateStock",
  async ({ delegateId, startDate, endDate }, thunkAPI) => { // <--- Changé month par startDate/endDate
    try {
      const params = new URLSearchParams();
      params.append("delegateId", delegateId);
      
      // Envoi des dates de période au backend
      if (startDate) params.append("startDate", startDate);
      if (endDate) params.append("endDate", endDate);

      const response = await axiosService.get(getUrl(`/delegate-stocks/my-stock?${params.toString()}`));
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Erreur de chargement");
    }
  }
);

export const adjustStock = createAsyncThunk(
  "stocks/adjustStock",
  async ({ delegateId, sampleId, quantity, isSpecific, personId, date }, thunkAPI) => {
    try {
      const response = await axiosService.post(getUrl(`/delegate-stocks/adjust`), {
        delegateId,
        sampleId,
        quantity: parseInt(quantity, 10),
        isSpecific,
        personId,
        date: date || undefined // On envoie la date d'ajustement si fournie
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Erreur d'ajustement");
    }
  }
);

export const importStock = createAsyncThunk(
  "stocks/importStock",
  async (formData, thunkAPI) => {
    try {
      const response = await axiosService.post(
        getUrl(`/delegate-stocks/import/`), 
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data;
    } catch (error) {
      const errorMsg = error.response?.data?.message || "Erreur lors de l'importation";
      return thunkAPI.rejectWithValue(errorMsg);
    }
  }
);

// --- CORRECTIF ICI : On ajoute sampleId et isSpecific pour le filtrage ---
export const getStockHistory = createAsyncThunk(
  "stocks/getHistory",
  async ({ delegateId, sampleId, isSpecific, startDate, endDate }, thunkAPI) => {
    try {
      let url = getUrl(`/delegate-stocks/history?delegateId=${delegateId}`);
      if (sampleId) url += `&sampleId=${sampleId}`;
      if (isSpecific !== undefined) url += `&isSpecific=${isSpecific}`;
      // AJOUT DES FILTRES DE DATE
      if (startDate) url += `&startDate=${startDate}`;
      if (endDate) url += `&endDate=${endDate}`;
      
      const response = await axiosService.get(url);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Erreur historique");
    }
  }
);


export const getSpecificStockByDelegate = createAsyncThunk(
  "stocks/getSpecificStockByDelegate",
  async (delegateId, thunkAPI) => {
    try {
      // On utilise l'URL vers la nouvelle route du backend
      const response = await axiosService.get(getUrl(`/delegate-stocks/specific-by-delegate/${delegateId}`));
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Erreur de chargement");
    }
  }
);

export const getGlobalSampleSummary = createAsyncThunk(
  "stocks/getGlobalSampleSummary",
  async ({ sampleId, startDate, endDate }, thunkAPI) => {
    try {
      const params = new URLSearchParams();
      if (startDate) params.append("startDate", startDate);
      if (endDate) params.append("endDate", endDate);

      // On appelle la route GLOBALE
      const response = await axiosService.get(
        getUrl(`/delegate-stocks/analytics/sample-global-summary/${sampleId}?${params.toString()}`)
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Erreur");
    }
  }
);